export const identity = {
    roles: {
        CS_USER: 'cs_user',
        TM: 'tm',
        PARTS: '1',
        WHOLEGOODS: '2',
        CREDIT: '6',
        GOVERNMENT_CONTRACTS: '9',
        SALES_MARKETING: '5',
        SERVICE: '3',
        WARRANTY: '4',
    },
    groups: {
        PEOPLE: 'b2e4c407-8d64-41f4-a0b6-d6c4e5e0f9e8',
        DEALERS: '1316cc5d-5171-43ad-a31b-ee9a7fd1ed98',
        DEALER_PEOPLE: '3a5e5283-ff3a-46c4-bd50-4553ce8a3008',
        ADMINS: '6eefde01-b2a3-4bba-9f8f-342633b2b074',
    }
};
